var map = {
	"./bet-records-1-num.png": "kng0",
	"./bet-records-1.png": "xSYn",
	"./bet-records-2-num.png": "Ds2N",
	"./bet-records-2.png": "70ho",
	"./bet-records-3-num.png": "0/q8",
	"./bet-records-3.png": "HV5I",
	"./bet-records-flag-unknown.png": "nkOC",
	"./bet-records-title.png": "i1+i",
	"./bg_prizepool.png": "XhgK",
	"./body-bg.png": "ge//",
	"./button_confirm_selected.png": "qrnT",
	"./demo-dialog-1.png": "p1h1",
	"./demo-dialog-2.png": "e6e5",
	"./dialog-button-cancel.png": "Q8b4",
	"./dialog-button-confirm.png": "mHpT",
	"./dialog-claim-button-confirm.png": "N42T",
	"./dialog-flag-germany.png": "GrMT",
	"./dialog-icon.png": "8Sam",
	"./event-period-title.png": "0t2t",
	"./flag-frame-idle.png": "uKrH",
	"./flag-frame-selected-up.png": "DVB1",
	"./flag-germany.png": "oDNm",
	"./foot-logo-1.png": "2muW",
	"./foot-logo-2.png": "u34L",
	"./foot-logo-3.png": "Qb/T",
	"./foot-logo-4.png": "nsW6",
	"./foot-logo-5.png": "ROpk",
	"./foot-logo-6.png": "eOzm",
	"./head-bg.png": "YBov",
	"./head-h1.png": "ojJ0",
	"./head-h2.png": "h+j2",
	"./head-instruction.png": "ajkU",
	"./head-total-money.png": "xzBI",
	"./how-to-join-arrow.png": "AaZY",
	"./how-to-join-line.png": "fHDZ",
	"./how-to-join-step-1-title.png": "2xxC",
	"./how-to-join-step-1.png": "7Zeo",
	"./how-to-join-step-2-title.png": "ogBb",
	"./how-to-join-step-2.png": "/2+G",
	"./how-to-join-step-3-title.png": "NnuY",
	"./how-to-join-step-3.png": "IsKs",
	"./how-to-join-step-4-title.png": "TYSv",
	"./how-to-join-step-4.png": "lrsI",
	"./how-to-join-title.png": "iScI",
	"./mt-logo.png": "+IR8",
	"./page_arrow_left.png": "l8GA",
	"./page_arrow_right.png": "mKHE",
	"./start-prediction-button.png": "0iua",
	"./start-prediction-icon.png": "lRNn",
	"./start-prediction-title.png": "Oc7b",
	"./start-prediction.png": "uPBK",
	"./theme-banner-title.png": "TVAE",
	"./ticket-claim-button.png": "3N1C",
	"./ticket-claim-title.png": "/E4r"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "hZGD";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fifa2026/images nonrecursive \.png$
// module id = hZGD
// module chunks = 1